var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.VerticalMenu = new Class({
    Extends: OCS.WxBriefing.Classes.MenuObj,
    active: false,
    options: {
        menu_class_name: "vertical_menu",
        element_class_name: "vertical_menu_container"
    },
    get_menu_element_obj: function (li) {

    }
});
OCS.Bootstrap.addEvent(OCS.Bootstrap.event_names.loading_phase_completed, function () {
    if (OCS.device.mobile) {
        OCS.WxBriefing.Classes.VerticalMenu.implement(OCS.WxBriefing.Interfaces.MobileVerticalMenu);
    } else {
        OCS.WxBriefing.Classes.VerticalMenu.implement(OCS.WxBriefing.Interfaces.DesktopVerticalMenu);
    }
});

